const createChatMessage = (id, role, text, status, metadata) => ({
  id,
  role,
  text,
  status,
  createdAt: new Date().toISOString(),
  feedback: null,
  feedbackSubmitted: false,
  retryPrompt: '',
  feedbackDetail: '',
  ...metadata
});

export default createChatMessage;
